import React, { useContext, useMemo } from "react";
import useRequest from "utils/useRequest";
import { anewExerciseStudentList } from "service/exercise";
import { TreeNode } from "service/notice";
import StudentPicker from "components/StudentPicker";
import { Spin } from "antd";
import { CourseContext } from "../../../../../Store";
import { TreeNodeType } from "components/StudentPicker/Components/TreeView";
import { isTrue } from "service/service";
import styles from "./index.module.scss";

interface StudentPickerProps {
    id: number;
    weekTimeId: number;
    onChange?(value?: string[]): void;
}

export default function StuPicker({
    id,
    weekTimeId,
    onChange
}: StudentPickerProps) {
    const { course } = useContext(CourseContext);

    const [data, { loading }] = useRequest(() =>
        anewExerciseStudentList(id, weekTimeId)
    );

    const treeData = useMemo<TreeNode[]>(() => {
        if (!data) return [];

        return [
            {
                key: course.courseId,
                title: course.courseName,
                value: course.courseId,
                label: course.courseName,
                children: data.map(item => ({
                    key: item.studentId,
                    title: item.name,
                    value: item.studentId,
                    label: `${item.name}(${item.studentId})`
                }))
            }
        ];
    }, [data]);

    function renderNode(node: TreeNodeType) {
        if (!data) return;
        const { key } = node;
        const stuInfo = data.find(item => item.studentId === key);

        if (node.key === course.courseId) return course.courseName;

        return (
            <div>
                {isTrue(stuInfo?.flag) ? (
                    <span className={styles.grey}>已参与</span>
                ) : (
                    <span className={styles.blue}>未参与</span>
                )}
                {stuInfo?.name}({stuInfo?.studentId})
            </div>
        );
    }

    if (loading) return <Spin />;
    return (
        <StudentPicker
            treeData={treeData}
            onChange={val => onChange?.(val)}
            renderNode={renderNode}
        />
    );
}
